import React, {useEffect, useState} from 'react';
import TextInput from '../../../../../Shared/TextInput/TextInput';
import PaperPlane from '../../SVG/PaperPlane';
import Phone from '../../SVG/Phone';
import PopUp from '../../../../../Shared/Popup/PopUp';
import './detailsInsertScreen.scss';
import BtnRightSideText from '../../../../../Shared/Buttons/BtnRightSideText';
import {getReportParams, report} from '../../../../../../middleware/report';
import gaParams from '../../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../../utilities/analytics/tracking';

const DetailsInsertScreen = (props) => {
  const [customerId, setId] = useState(props.customerId);
  const [firstName, setFirstName] = useState(props.customerFirstName);
  const [lastName, setLastName] = useState(props.customerLastName);
  const [mailAddress, setMailAddress] = useState(props.customerEmail);
  const [errorObj, setErrorObj] = useState({
    idError: null,
    mailError: null,
    firstError: null,
    lastError: null,
  });
  const [toShowPopUp, setShowPopUp] = useState(false);
  const [showCode, setShowCode] = useState(false);

  useEffect(() => {
    gaEvent(
      gaParams.SEPARATED_DETAILINSERTSCREEN_SHOW.category,
      gaParams.SEPARATED_DETAILINSERTSCREEN_SHOW.eventType,
      gaParams.SEPARATED_DETAILINSERTSCREEN_SHOW.eventParams
    );
  }, []);

  const is_israeli_id_number = (id) => {
    return (
      /\d{9}/.test(id) &&
      !id.match(/^0*$/) &&
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
        0
    );
  };

  const mailValidation = () => {
    const regMail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regMail.test(String(mailAddress).toLowerCase());
  };

  const validateDetails = () => {
    gaEvent(
      gaParams.SEPARATED_DETAILCONTINUE_CLICK.category,
      gaParams.SEPARATED_DETAILCONTINUE_CLICK.eventType,
      gaParams.SEPARATED_DETAILCONTINUE_CLICK.eventParams
    );
    if (firstName && lastName && mailAddress && customerId) {
      if (mailValidation()) {
        props
          .debtCheck({
            id: customerId,
            subscriber: props.subscriber,
            fromExisting: props.subscriberData.validatedCostumerData.shadowData.shadowClientValid,
          })
          .then((res) => {
            const debtChecker = res.payload.Body;
            if (debtChecker) {
              let errorNew = {...errorObj, idError: ' '};
              setErrorObj(errorNew);
              setShowCode(true);
              setShowPopUp(true);
              gaEvent(
                gaParams.SEPARATED_DETAILDEBT_SHOW.category,
                gaParams.SEPARATED_DETAILDEBT_SHOW.eventType,
                gaParams.SEPARATED_DETAILDEBT_SHOW.eventParams
              );
            } else {
              let reportParams = getReportParams();
              reportParams.area = 'SelfCare';
              reportParams.subArea = 'Cellcom Abroad';
              reportParams.channel = 'WebsiteBusiness';
              reportParams.actionType = 'Separated details inserted';
              reportParams.status = 'Ongoing';
              reportParams.messageText = 'Separated details inserted';
              reportParams.param1 = 'WEBSITE';
              if (props.isJET) {
                reportParams.param1 = 'JET';
              }
              reportParams.param3 = 'מכר בהפרדה';
              reportParams.subscriber = props.subscriber;
              report(reportParams);

              props.handler({
                customerId: customerId,
                customerFirstName: firstName,
                customerLastName: lastName,
                customerEmail: mailAddress,
              });
            }
          });
      } else {
        let newState = {...errorObj, mailError: 'כתובת אימייל לא תקינה'};
        setErrorObj(newState);
      }
    } else {
      setErrorObj({
        idError: customerId ? null : ' ',
        mailError: mailAddress ? null : mailValidation() ? ' ' : 'כתובת אימייל לא תקינה',
        firstError: firstName ? null : ' ',
        lastError: lastName ? null : ' ',
      });
    }
  };

  let idInput = (
    <TextInput
      placeholder='תעודת זהות'
      name='id'
      maxLength='9'
      value={customerId}
      type='text'
      inputMode='numeric'
      onChange={(e) => {
        setId(e.target.value.replace(/[^0-9]/g, ''));
        let errorNew = {...errorObj, idError: null};
        setErrorObj(errorNew);
      }}
      error={errorObj.idError}
    />
  );
  if (props.lockId) {
    idInput = <TextInput placeholder='תעודת זהות' name='id' value={props.customerId} type='number' disabled='disabled' />;
  }
  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (customerId && firstName && lastName && mailValidation() && is_israeli_id_number(customerId)) {
            validateDetails();
          }
        }}>
        <div className='cellcomSeparatedDetailsInsert'>
          <div className='subscriberHeading'>מנוי {props.subscriber}</div>
          <div className='mainHeading'>רגע לפני שממשיכים...</div>
          <div className='subparagraph'>
            <b>חבילת חו"ל הינה בעלות נפרדת מהמנוי העסקי שלכם</b>
            <br />
            הפרטים שתזינו כאן ישמשו לרכישת החבילה
          </div>
          <div className='subparagraph'>שימו לב, כדי לרכוש את החבילה דרך הארגון, יש לפנות לאיש הקשר</div>
          <div className='personalDetailsInsert'>
            <div>
              <b className='heading'>פרטים אישיים</b>
              <div className='subHeading'>כל השדות הינם שדות חובה</div>
            </div>
            {idInput}
            <TextInput
              placeholder='שם פרטי'
              name='firstName'
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value.replace(/[^a-z\u0590-\u05FF\s]/g, ''));
                let errorNew = {...errorObj, firstError: null};
                setErrorObj(errorNew);
              }}
              error={errorObj.firstError}
            />
            <TextInput
              placeholder='שם משפחה'
              name='lastName'
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value.replace(/[^a-z\u0590-\u05FF\s]/g, ''));
                let errorNew = {...errorObj, lastError: null};
                setErrorObj(errorNew);
              }}
              error={errorObj.lastError}
            />
            <TextInput
              type='email'
              placeholder='כתובת מייל לשליחת החשבונית'
              name='mailAddress'
              value={mailAddress}
              onChange={(e) => {
                setMailAddress(e.target.value);
                let errorNew = {...errorObj, mailError: null};
                setErrorObj(errorNew);
              }}
              error={errorObj.mailError}
            />
          </div>
          <PopUp
            showPopUp={toShowPopUp}
            onClose={() => {
              setShowPopUp(false);
              setShowCode(false);
            }}>
            <div className='mainHeading p-0 m-0'>רק רגע, יש פה עניין</div>
            <div className='plane'>
              <PaperPlane />
            </div>
            <div className='popupExplanation'>
              <b>
                אי אפשר לרכוש חבילת חו"ל עם תעודת
                <br />
                הזהות שהזנת
              </b>
            </div>
            {showCode ? <div className='popupCode'>(10)</div> : null}
            <div className='popupContactBox'>
              <div className='popupContactExplanation'>לבירור אפשר להתקשר למוקד השירות שלנו</div>
              <div
                className='contactWrapper'
                onClick={() => {
                  window.location.href = `tel:${window.Config.financeCallNumber2}`;
                }}>
                <Phone />
                <span style={{padding: '0 7px'}}>הקליקו לשיחה</span>
                <span>{window.Config.financeCallNumber2}</span>
              </div>
            </div>
            <a
              href='#'
              className='popupCloseLink'
              onClick={() => {
                gaEvent(
                  gaParams.SEPARATED_DIFFERENTID_CLICK.category,
                  gaParams.SEPARATED_DIFFERENTID_CLICK.eventType,
                  gaParams.SEPARATED_DIFFERENTID_CLICK.eventParams
                );
                setShowPopUp(false);
              }}>
              רוצה לנסות עם ת.ז אחרת?
            </a>
          </PopUp>
        </div>
        <div className='cellcomSeparatedDetailsInsert_separatedFooter'>
          <BtnRightSideText
            text='המשך'
            isBusiness={true}
            onClick={(e) => {
              e.preventDefault();
              if (customerId && firstName && lastName && mailValidation() && is_israeli_id_number(customerId)) {
                validateDetails();
              }
            }}
            isGreyBg={customerId && firstName && lastName && mailValidation() && is_israeli_id_number(customerId) ? false : true}
          />
        </div>
      </form>
    </>
  );
};

export default DetailsInsertScreen;
